<script lang="ts" setup>
import PalkLogoColor from "@/components/PalkLogoColor.vue";
import {useRoute, useRouter} from "vue-router";

defineOptions({
  name: "AdminPage",
});
const props = defineProps<{
  path: string;
}>();
const router = useRouter();
const route = useRoute();
const root = "/adminv1";

if (route.path === '/') {
  if (props.path && props.path !== '') {
    router.replace(`${root}/${props.path}`);
  } else {
    // Default path if no specific path is provided
    router.replace(`${root}/companies`);
  }
}
</script>

<template>
  <div class="admin-page">
    <h1>
      <palk-logo-color/>
      admin
    </h1>

        <nav class="admin-page-nav">
          <router-link class="admin-page-link" to="/adminv1/companies">Companies</router-link>
          <router-link class="admin-page-link" to="/adminv1/demo">Demo area</router-link>
        </nav>
        <div class="admin-page-content">
          <router-view/>
        </div>
  </div>
</template>
<style scoped>
.admin-page {
  max-width: 1200px;
  width: 100%;
  margin: 40px auto;
  background: #ffffff;
  padding: 32px 36px 40px 36px;
  border-radius: 1px;
  border: 1px solid #999999;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.admin-page-nav {
  display: flex;
  flex-direction: row;
  background: #e8edf2;
  border-radius: 0;
  margin-bottom: 32px;
  min-height: 58px;
  gap: 0;
}

/* Unselected admin page links */
.admin-page-link {
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  letter-spacing: 0.02em;
  background: #fff;
  color: #888888;
  border: none;
  border-radius: 0;
  font-size: 14px;
  padding: 0 32px;
  height: 56px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.13s, color 0.13s, border-bottom 0.13s;
  border-bottom: 4px solid transparent;
}

.admin-page-link.router-link-exact-active {
  color: #2eb336;
  border-bottom: 4px solid #2eb336;
  background: #fff; /* keep background unchanged */
}

/* Optional: Hover effect for non-active tabs */
.admin-page-link:not(.router-link-exact-active):hover {
  background: #f5f7f9;
}

@media (max-width: 700px) {
  .admin-page-nav {
    flex-direction: column;
    min-height: unset;
  }
  .admin-page-link {
    width: 100%;
    justify-content: flex-start;
    padding: 0 14px;
    height: 48px;
  }
}
</style>